import { api, HEADERS } from '~config/api';

export const UserService = {
  searchUser: async ({ search }) => {
    const input = search.trim();
    if (!input) return Promise.reject(new Error('El campo de búsqueda está vacío'));

    const phoneRegex = /^\+?[0-9]+$/;
    if (phoneRegex.test(input)) {
      // Quitar el + si existe
      const phone = input.startsWith('+') ? input.slice(1) : input;
      const response = await api.get(`/v1/admin/users?phone=${phone}`);
      return response?.data.page;
    } else {
      const response = await api.get(`/v1/admin/users?query=${input}`);
      return response?.data;
    }
  },

  createGuestUser: ({ user }) => {
    const createUserToken = process.env.REACT_APP_FIREBASE_ID_REACT_APP_CREATE_USER_TOKEN;
    if (!createUserToken) {
      console.error('CREATE_USER_TOKEN no está definido');
      throw new Error('Token de creación de usuario no configurado');
    }

    const headers = {
      [HEADERS.CREATE_USER_TOKEN]: createUserToken
    };
    return api.post(`/v1/users`, { user }, { headers });
  },

  updateUser: async ({ userId, userData }) => {
    try {
      const response = await api.patch(`/v1/admin/users/${userId}`, { user: userData });
      return response?.data;
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  }
};
